import { render, staticRenderFns } from "./HeaderLink.vue?vue&type=template&id=39c1d0cd"
import script from "./HeaderLink.vue?vue&type=script&lang=js"
export * from "./HeaderLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports